import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card,
  Page,
  Radio,
  RadioGroup,
  Text,
} from '../../components';
import { updateFontSizeOverride } from '../../modules/fontSizeOverride';
import { getFontSizeOverride, getThemeWithoutOverrides } from '../../modules/selectors';

const propTypes = {
  themeWithoutOverrides: PropTypes.shape({
    fontSize_base: PropTypes.string,
  }).isRequired,
  fontSizeOverride: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

const defaultProps = {
  fontSizeOverride: undefined,
};

class Resize extends Component {
  handleClick = (font) => {
    const { dispatch } = this.props;
    dispatch(updateFontSizeOverride(font));
  }

  render() {
    const { fontSizeOverride, themeWithoutOverrides } = this.props;
    const fontBase = themeWithoutOverrides.fontSize_base || '16px';
    const fontSizeOptions = [
      { description: 'Normal', size: fontBase },
      { description: 'Large', size: `${parseInt(fontBase, 10) * 1.125}px` },
      { description: 'Extra Large', size: `${parseInt(fontBase, 10) * 1.25}px` },
    ];
    const renderRadioButton = fontSizeOptions.map(font => (
      <Radio
        key={font.description}
        name={font.description}
        value={font.size}
        label={font.description}
        onChange={() => this.handleClick(font.size)}
      />
    ));
    return (
      <Page>
        <Card>
          <Card.Block>
            <Text as="h1">Text Resizing</Text>
            <RadioGroup name="fontResizing" defaultChecked={fontSizeOverride || fontBase}>
              {renderRadioButton}
            </RadioGroup>
          </Card.Block>
        </Card>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    themeWithoutOverrides: getThemeWithoutOverrides(state),
    fontSizeOverride: getFontSizeOverride(state),
  };
}
Resize.propTypes = propTypes;
Resize.defaultProps = defaultProps;
export default connect(mapStateToProps)(Resize);
